<template>
  <div class="dashboard-container" :class="{ 'no-scroll': sidebarOpen && isMobile }">
    <!-- Sidebar -->
    <aside class="sidebar" :class="{ open: sidebarOpen }">
      <h2 class="logo">Jiku<span>Ops</span></h2>

      <div class="menu-label">MENU</div>

      <ul class="menu" @click="closeSidebarIfMobile">
        <li>
          <router-link to="/dashboard">
            <span class="icon">🏠</span> Dashboard
          </router-link>
        </li>
        <li class="has-dropdown" :class="{ open: openDropdown === 'nasabah' }" @click.stop="toggleDropdown('nasabah')">
          <a href="#">
            <span><span class="icon">📚</span> Nasabah</span>
          </a>
          <ul v-show="openDropdown === 'nasabah'" class="submenu">
            <li><router-link to="/nasabah">👤 Data Nasabah</router-link></li>
            <li><router-link to="/nasabah/add">➕ Input Data</router-link></li>
          </ul>
        </li>
        <li>
          <a href="#" class="logout-link" @click.prevent="onLogout()">
            <span class="icon">🚪</span> Logout
          </a>
        </li>
      </ul>
    </aside>

    <!-- Backdrop untuk mobile -->
    <div v-if="sidebarOpen && isMobile" class="backdrop" @click="closeSidebar"></div>

    <!-- Main Content -->
    <main class="main-content">
      <!-- Top Navigation Header -->
      <header class="top-navbar">
        <button class="toggle-btn" @click="toggleSidebar">☰</button>
        <div class="header-right">
          <span class="bell-icon">🔔</span>
          <div class="user-avatar"></div>
        </div>
      </header>

      <!-- Content Header (Judul & Breadcrumb) -->
      <div class="content-header">
        <h1 class="page-title">{{ nama_bank }}</h1>
        <nav class="breadcrumb">
          <router-link to="/dashboard">Home</router-link>
          <span class="separator">›</span>
          <span class="active">Dashboard</span>
        </nav>
      </div>

      <!-- Content Body (LANGSUNG ROUTER-VIEW TANPA CARD PEMBUNGKUS) -->
      <div class="content-body">
        <router-view></router-view>
      </div>
    </main>
  </div>
</template>

<script>
import Swal from 'sweetalert2'

export default {
  name: "Layout",
  data() {
    return {
      nama_bank: JSON.parse(localStorage.getItem('user'))?.bank?.nama || 'Bank Nagari',
      sidebarOpen: false,
      isMobile: false,
      MOBILE_BREAKPOINT: 992,
      openDropdown: null,
    };
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("keydown", this.onKeydown);

    const expiresAt = localStorage.getItem('expires_at')
    if (!expiresAt || new Date(expiresAt) <= new Date()) {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('expires_at')
      this.$router.push('/')
    } else {
      const msUntilExpiry = new Date(expiresAt) - new Date()
      setTimeout(() => {
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        localStorage.removeItem('expires_at')
        this.$router.push('/')
      }, msUntilExpiry)
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= this.MOBILE_BREAKPOINT;
      if (!this.isMobile) this.sidebarOpen = false;
    },
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },
    closeSidebar() {
      this.sidebarOpen = false;
    },
    closeSidebarIfMobile() {
      if (this.isMobile) this.closeSidebar();
    },
    onKeydown(e) {
      if (e.key === "Escape" && this.sidebarOpen) this.closeSidebar();
    },
    toggleDropdown(menu) {
      this.openDropdown = this.openDropdown === menu ? null : menu;
    },
    onLogout(){
      Swal.fire({
        title: 'Anda yakin keluar ?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak'
      }).then(result => {
        if(result.isConfirmed){
          fetch(`${this.$apiURL}/v1/logout`, {
            method: 'POST',
            headers: {
              'Content-Type' : 'application/json',
              'Accept' : 'application/json',
              'Authorization' : 'Bearer ' + localStorage.getItem('token')
            }
          }).then(response => response.json())
          .then((result) => {
            if(result?.success){
              localStorage.removeItem('token')
              localStorage.removeItem('expires_at')
              localStorage.removeItem('user')
              this.$router.push('/')
            }
          })
        }
      })
    }
  },
};
</script>

<style scoped>
/* CSS Tambahan Khusus Layout ini */
.top-navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
}

.bell-icon {
  font-size: 1.2rem;
  cursor: pointer;
}

.user-avatar {
  width: 36px;
  height: 36px;
  background-color: #0b1953;
  border-radius: 50%;
}

.menu-label {
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  margin: 15px 0 8px 12px;
  letter-spacing: 0.5px;
}

.icon {
  margin-right: 10px;
  font-size: 1.1rem;
}

.logout-link {
  color: #ef4444 !important;
}

.logout-link:hover {
  background: #fef2f2 !important;
}
</style>